import React, { useEffect, useState } from "react";

export default function CountdownTimer() {
  const COOKIE_NAME = "countdown_start_time";
  const COUNTDOWN_DURATION = 3 * 24 * 60 * 60 * 1000 + 1000 * 60 * 60 + 1000 * 60; // 3 days + extra time

  // Function to get or set the countdown start time
  const getOrSetStartTime = () => {
    const storedTime = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${COOKIE_NAME}=`));

    if (storedTime) {
      return parseInt(storedTime.split("=")[1], 10); // Use existing time
    } else {
      const newStartTime = new Date().getTime();
      document.cookie = `${COOKIE_NAME}=${newStartTime}; path=/; max-age=${COUNTDOWN_DURATION / 1000}`; // Set cookie
      return newStartTime;
    }
  };

  const startTime = getOrSetStartTime();
  const targetTime = startTime + COUNTDOWN_DURATION;

  const calculateTimeRemaining = () => {
    const now = new Date().getTime();
    return Math.max((targetTime - now) / 1000, 0);
  };

  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining());
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [targetTime]);

  // Convert seconds to days, hours, minutes, and seconds
  const days = Math.floor(timeRemaining / 86400).toString().padStart(2, "0");
  const hours = Math.floor((timeRemaining % 86400) / 3600).toString().padStart(2, "0");
  const minutes = Math.floor((timeRemaining % 3600) / 60).toString().padStart(2, "0");
  const seconds = Math.floor(timeRemaining % 60).toString().padStart(2, "0");

  return (
    <div className="text-center w-100 bg-secondary rounded-2">
      <p className="fw-bold">Limited Time Deal – The Clock is Ticking!</p>
      <div className="d-flex justify-content-center gap-5">
        <div className="d-flex flex-column align-items-center">
          <p className="h3 text-tertiary bg-primary rounded-3 p-1">{days}</p>
          <p className="fs-6">Days</p>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p className="h3 text-tertiary bg-primary rounded-3 p-1">{hours}</p>
          <p className="fs-6">Hours</p>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p className="h3 text-tertiary bg-primary rounded-3 p-1">{minutes}</p>
          <p className="fs-6">Minutes</p>
        </div>
        <div className="d-flex flex-column align-items-center">
          <p className="h3 text-tertiary bg-primary rounded-3 p-1">{seconds}</p>
          <p className="fs-6">Seconds</p>
        </div>
      </div>
    </div>
  );
}
